const clickPrimary = { url: "/assets/sfx/sfx_click_primary.wav" };
const decisionSelect = { url: "/assets/sfx/sfx_decision_select.wav" };
const decisionLock = { url: "/assets/sfx/sfx_decision_lock.wav" };
const correctSoft = { url: "/assets/sfx/sfx_correct_soft.wav" };
const incorrectSoft = { url: "/assets/sfx/sfx_incorrect_soft.wav" };
const moneyGain = { url: "/assets/sfx/sfx_money_gain.wav" };
const moneyLoss = { url: "/assets/sfx/sfx_money_loss.wav" };
const softSwoosh = { url: "/assets/sfx/sfx_soft_swoosh.wav" };
const warningRisk = { url: "/assets/sfx/sfx_warning_risk.wav" };
const achievementUnlock = { url: "/assets/sfx/sfx_achievement_unlock.wav" };
const moduleStart = { url: "/assets/sfx/sfx_module_start.wav" };
const moduleComplete = { url: "/assets/sfx/sfx_module_complete.wav" };
const autoDeductionTick = { url: "/assets/sfx/sfx_auto_deduction_tick.wav" };
const resultReveal = { url: "/assets/sfx/sfx_result_reveal.wav" };
const holoReveal = { url: "/assets/sfx/sfx_holo_reveal.wav" };
const walletUpdate = { url: "/assets/sfx/sfx_wallet_update.wav" };
const progressFill = { url: "/assets/sfx/sfx_progress_fill.wav" };
const panelOpen = { url: "/assets/sfx/sfx_panel_open.wav" };
const panelClose = { url: "/assets/sfx/sfx_panel_close.wav" };
const clickSecondary = { url: "/assets/sfx/sfx_click_secondary.wav" };

export const SFX_MAP = {
  click_primary: clickPrimary.url,
  decision_select: decisionSelect.url,
  decision_lock: decisionLock.url,
  correct_soft: correctSoft.url,
  incorrect_soft: incorrectSoft.url,
  money_gain: moneyGain.url,
  money_loss: moneyLoss.url,
  soft_swoosh: softSwoosh.url,
  warning_risk: warningRisk.url,
  achievement_unlock: achievementUnlock.url,
  module_start: moduleStart.url,
  module_complete: moduleComplete.url,
  auto_deduction_tick: autoDeductionTick.url,
  result_reveal: resultReveal.url,
  holo_reveal: holoReveal.url,
  wallet_update: walletUpdate.url,
  progress_fill: progressFill.url,
  panel_open: panelOpen.url,
  panel_close: panelClose.url,
  click_secondary: clickSecondary.url,
} as const;

export type SfxName = keyof typeof SFX_MAP;

export const SFX_PRIORITY: Record<SfxName, number> = {
  money_loss: 100,
  warning_risk: 97,
  incorrect_soft: 95,
  module_complete: 90,
  achievement_unlock: 85,
  correct_soft: 80,
  money_gain: 75,
  result_reveal: 70,
  decision_lock: 60,
  module_start: 55,
  wallet_update: 50,
  progress_fill: 49,
  holo_reveal: 48,
  panel_open: 42,
  panel_close: 40,
  decision_select: 38,
  auto_deduction_tick: 35,
  click_secondary: 32,
  soft_swoosh: 30,
  click_primary: 20,
};
